import { render, staticRenderFns } from "./StockClosingDetail.vue?vue&type=template&id=0825c7a4&"
import script from "./StockClosingDetail.vue?vue&type=script&lang=js&"
export * from "./StockClosingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports